import { Trans, useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import envSettings from "../../../services/system/envSettings";

const FooterPanel = () => {
  const { t } = useTranslation();
  return (
    <div className="container-fluid">
      <div className="row py-4">
        <div className="col-12 col-lg">
          <p className="mb-lg-0">
            <NavLink to={envSettings.AVAILABILITY_STATEMENT_EXT} className="related-link">
              {t("navigatePanel.footerPanel.availabilityStatement")}
            </NavLink>
          </p>
        </div>
        <div className="col-12 col-lg">
          <p className="mb-lg-0">
            <NavLink to="tel:72221818" className="related-link">
              <Trans i18nKey="navigatePanel.footerPanel.phoneContact" values={{ phoneNumber: "72 22 18 18" }} />
            </NavLink>
          </p>
        </div>
        <div className="col-12 pr-0 col-lg-auto">
          <p className="mb-lg-0">
            <NavLink to={envSettings.PRIVACY_POLICY_COOKIES_EXT} className="related-link">
              {t("navigatePanel.footerPanel.cookies")}
            </NavLink>
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col footer-info text-lg-center">{t("navigatePanel.footerPanel.info")}</div>
      </div>
    </div>
  );
};

export default FooterPanel;
